import { TestimonialListProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: TestimonialListProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as TestimonialListProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
